<template>
    <!-- 显示设置组件
        @author: liuguisheng
        @date: 2019-11-21
    -->
    <div class="setting-item">
    <el-form-item label="空值是否渲染"> 
        <el-radio-group v-model="nullRender" size="small">
          <el-radio-button label="1">渲染</el-radio-button>
          <el-radio-button label="0">不渲染</el-radio-button>
        </el-radio-group>
    </el-form-item>
  </div>
</template>
<script>
// 导入value监听混入
import mixValueWatch from '@/mixins/common/mix_value_watch.js';
// 导入计算属性映射方法
import { mapComputed } from '@/mixins/common/mix_value_watch.js';
export default {
  mixins: [ mixValueWatch ],
  computed: {
    /** @name 显示设置
     *  @description 将 nullRender 字段映射到当前 nullRender 计算属性
     *  @return { Object }
     *  @author liuguisheng
     *  @version 2019-11-21
     */
    ...mapComputed({
      nullRender: { 
        parent: i => i.renderOption,
        attr: "nullRender"
      }
    })
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Setting/render_setting/RenderNullRender.vue